import { render, staticRenderFns } from "./EjercicioExci.vue?vue&type=template&id=bd591c20&scoped=true"
import script from "./EjercicioExci.vue?vue&type=script&lang=js"
export * from "./EjercicioExci.vue?vue&type=script&lang=js"
import style0 from "./EjercicioExci.vue?vue&type=style&index=0&id=bd591c20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd591c20",
  null
  
)

export default component.exports